/*switch the entire card-product based on selected individual product swatch*/
window.initCardProductSwitch = function () {
  document.querySelectorAll('.card-wrapper .color-swatch-button').forEach(button => {
    // Prevent duplicate listeners
    if (button.dataset.listenerAttached === "true") return;

    button.dataset.listenerAttached = "true";

    button.addEventListener('click', function () {
      const handle = this.dataset.productHandle;
      const currentCard = this.closest('.card-wrapper.product-card-wrapper');

      if (!handle || !currentCard) {
        console.warn('Missing product handle or .card-wrapper.product-card-wrapper');
        return;
      }

      fetch(`/products/${handle}?section_id=card-product-section`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCard = doc.querySelector('[data-product-wrapper]');

          if (newCard) {
            currentCard.replaceWith(newCard);

            // Re-init logic
            if (typeof window.initQuickAdd === 'function') {
              window.initQuickAdd(newCard);
            }
            if (typeof window.initNotifyMeForm === 'function') {
              window.initNotifyMeForm();
            }

            if (typeof window.initCardProductSwitch === 'function') {
              window.initCardProductSwitch(); // re-bind
            }
            if (typeof window.initQuickAddBySize === 'function') {
              window.initQuickAddBySize(); // re-bind
            }
            if (typeof window.initCardMediaCarousel === 'function') {
              window.initCardMediaCarousel(); // re-bind
            }
          } else {
            console.warn('New card-product not found in loaded HTML.');
          }
        })
        .catch(err => {
          console.error(`❌ Failed to load section for ${handle}`, err);
        });
    });
  });
};

// ✅ Run on initial load
document.addEventListener('DOMContentLoaded', function () {
  window.initCardProductSwitch();
});

/*switch the entire card-product based on selected individual product swatch*/


/*Custom quick add on card-product.liquid*/
function initQuickAdd(scope = document) {
  scope.querySelectorAll('.card-product').forEach(productCard => {
    const handle = productCard.dataset.productHandle;

    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(productData => {
        // Trigger initial selection
        productCard.querySelectorAll('.variant-swatch[aria-current="true"]').forEach(swatch => swatch.click());

        productCard.querySelectorAll('.variant-swatch').forEach(swatch => {
          swatch.addEventListener('click', function () {
            const swatchGroup = this.closest('.variant-swatches');
            const optionIndex = parseInt(this.dataset.optionIndex, 10);

            // Update UI selection
            swatchGroup.querySelectorAll('.variant-swatch').forEach(btn => btn.removeAttribute('aria-current'));
            this.setAttribute('aria-current', 'true');

            // Build selection
            const selectedOptions = [];
            productCard.querySelectorAll('.variant-swatches').forEach((group, i) => {
              const selected = group.querySelector('[aria-current="true"]');
              selectedOptions[i] = selected ? selected.dataset.value : null;
            });

            const form = productCard.querySelector('form');
            const variantIdInput = form.querySelector('input[name="id"]');
            const addButton = form.querySelector('.quick-add-button');

            // Match correct variant
            const matchedVariant = productData.variants.find(v =>
              v.options.every((opt, idx) => !selectedOptions[idx] || opt === selectedOptions[idx])
            );

            if (matchedVariant) {
              variantIdInput.value = matchedVariant.id;

              if (matchedVariant.available) {
                addButton.classList.remove('disabled');
                addButton.querySelector('.button-text').textContent = 'Add to cart';
              } else {
                addButton.classList.add('disabled');
                addButton.querySelector('.button-text').textContent = 'Sold out';
              }
            }

            // Update availability for all swatches
            productCard.querySelectorAll('.variant-swatches').forEach((group, groupIndex) => {
              group.querySelectorAll('.variant-swatch').forEach(btn => {
                const testOptions = [...selectedOptions];
                testOptions[groupIndex] = btn.dataset.value;

                const isAvailable = productData.variants.some(v =>
                  v.available && v.options.every((opt, idx) => !testOptions[idx] || opt === testOptions[idx])
                );

                btn.classList.toggle('disabled', !isAvailable);
              });
            });

            // Update visible selected label
            const label = swatchGroup.closest('.variant-option')?.querySelector('.variant-option__label .selected-value');
            if (label) label.textContent = this.dataset.value;
          });
        });
      })
      .catch(err => {
        console.error(`❌ Failed to fetch product ${handle}`, err);
      });
  });
}


document.addEventListener('DOMContentLoaded', () => {
  window.initQuickAdd();
});
/*Custom quick add on card-product.liquid*/

// Reinitiate product switch and quick add function when filtered
const observer = new MutationObserver(() => {
  console.log('🟢 Mutation detected – reinitializing');
  
  if (typeof window.initCardProductSwitch === 'function') {
    window.initCardProductSwitch();
  }

  if (typeof window.initNotifyMeForm === 'function') {
    window.initNotifyMeForm();
  }

  if (typeof window.initQuickAdd === 'function') {
    window.initQuickAdd();
  }
  if (typeof window.initCardMediaCarousel === 'function') {
    window.initCardMediaCarousel();
  }
  if (typeof window.initQuickAddBySize === 'function') {
    window.initQuickAddBySize();
  }
});

// Grab both elements: by ID and tag name
const targets = [
  document.getElementById('FacetFiltersFormMobile'),
  document.querySelector('product-recommendations')
];

targets.forEach((target) => {
  if (target) {
    observer.observe(target, {
      childList: true,
      subtree: true
    });
    console.log(`👁️ Observing ${target.tagName || target.id}`);
  } else {
    console.warn(`❌ Could not find target to observe`);
  }
});
// Reinitiate product switch and quick add function when filtered

//FAQ toggle on product page
  window.initFAQAccordion = function () {
    document.querySelectorAll(".faq-toggle").forEach((toggle) => {
      toggle.addEventListener("click", function () {
        const answer = toggle.nextElementSibling;
        const isExpanded = toggle.getAttribute("aria-expanded") === "true";

        toggle.setAttribute("aria-expanded", String(!isExpanded));
        answer.classList.toggle("open", !isExpanded);
      });
    });
  };
// Auto-run on initial load
document.addEventListener("DOMContentLoaded", window.initFAQAccordion);
//FAQ toggle on product page

//TABS toggle on product page
window.initAccordion = function () {
  const items = document.querySelectorAll('.accordion-item');

  items.forEach(item => {
    const header = item.querySelector('.accordion-header');
    const icon = item.querySelector('.accordion-icon');
    const content = item.querySelector('.accordion-content');

    header.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');

      // Close all
      items.forEach(i => {
        i.classList.remove('open');
        i.querySelector('.accordion-content').style.maxHeight = null;
      });

      // Reopen if it wasn't already open
      if (!isOpen) {
        item.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });

    // Handle default open state
    if (item.classList.contains('open')) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
};

// Auto-run on initial load
document.addEventListener("DOMContentLoaded", window.initAccordion);
//TABS toggle on product page

//wishcard message toggle
window.initWishCardToggle = function () {
  const checkbox = document.getElementById("toggle_wish_card");
  const messageBox = document.getElementById("wish_card_container");

  if (checkbox && messageBox) {
    checkbox.addEventListener("change", function () {
      messageBox.style.display = this.checked ? "block" : "none";
    });

    // Optional: set initial state on load
    messageBox.style.display = checkbox.checked ? "block" : "none";
  }
};


  // Auto-run on initial load
  document.addEventListener("DOMContentLoaded", function () {
    window.initWishCardToggle();
  });

//End of wishcard message toggle

//Size guide JS
window.initSizeGuide = function () {
  const container = document.querySelector('.size-chart-content');
  if (!container) return;

  // ----- Tab Navigation -----
  const buttons = container.querySelectorAll('[data-tab-target]');
  const tabs = container.querySelectorAll('.tab-content');

  buttons.forEach(btn => btn.classList.remove('active'));
  tabs.forEach(tab => tab.classList.remove('active'));

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const targetId = button.getAttribute('data-tab-target');
      const targetTab = container.querySelector(`#${targetId}`);
      buttons.forEach(btn => btn.classList.remove('active'));
      tabs.forEach(tab => tab.classList.remove('active'));
      button.classList.add('active');
      if (targetTab) targetTab.classList.add('active');
    });
  });

  const firstTab = container.querySelector('.tab-content');
  const firstButton = container.querySelector('.size-chart-tabs button');
  if (firstTab) firstTab.classList.add('active');
  if (firstButton) firstButton.classList.add('active');

  // ----- Size Chart Tab -----
  const sizeContainer = document.getElementById("sizeGuideTableContainer");
  const sizeChartDataRaw = document.getElementById("size-chart-data")?.dataset.html;
  const desktopImageRaw = document.getElementById("size-guide-image-desktop")?.dataset.img;
  const mobileImageRaw = document.getElementById("size-guide-image-mobile")?.dataset.img;
  const toggleContainer = document.getElementById("unitToggleContainer");
  const toggle = document.getElementById("unitToggle");

  const convertValue = (value) => {
    if (!value || value.trim() === "-" || value.trim() === "") return value;
    const parts = value.split(/–|-/).map(p => p.trim());
    return parts.map(p => {
      const num = parseFloat(p);
      return isNaN(num) ? p : (num / 2.54).toFixed(1);
    }).join(" – ");
  };

  function renderSizeChartFallback() {
    try {
      const data = JSON.parse(sizeChartDataRaw);
      if (!data.columns || !data.rows) throw new Error("Invalid table structure");

      const table = document.createElement("table");
      table.className = "size-guide-table";

      const thead = document.createElement("thead");
      const headRow = document.createElement("tr");
      data.columns.forEach((col) => {
        const th = document.createElement("th");
        th.textContent = col;
        headRow.appendChild(th);
      });
      thead.appendChild(headRow);
      table.appendChild(thead);

      const tbody = document.createElement("tbody");
      data.rows.forEach((row) => {
        const tr = document.createElement("tr");
        data.columns.forEach((col, index) => {
          const td = document.createElement("td");
          td.setAttribute("data-cm", row[col] || "");
          td.textContent = row[col];
          if (index !== 0) td.setAttribute("data-original", row[col]);
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);

      sizeContainer.innerHTML = "";
      sizeContainer.appendChild(table);
    } catch (err) {
      console.error("❌ Error rendering size table:", err);
      sizeContainer.textContent = "Unable to load size chart.";
    }
  }

  function updateUnit(unit = "cm") {
    const cells = sizeContainer.querySelectorAll("td[data-original]");
    cells.forEach(td => {
      const cmValue = td.getAttribute("data-original");
      td.textContent = unit === "in" ? convertValue(cmValue) : cmValue;
    });
  }

  function renderSizeTable() {
    const useMobile = window.innerWidth < 740;
    const desktopImage = desktopImageRaw?.trim();
    const mobileImage = mobileImageRaw?.trim();
    const selectedImage = useMobile && mobileImage ? mobileImage : desktopImage;

    if (selectedImage) {
      if (toggleContainer) toggleContainer.style.display = "none";

      const img = document.createElement("img");
      img.src = selectedImage;
      img.alt = "Size Guide";
      img.style.width = "100%";
      img.loading = "lazy";
      img.onerror = function () {
        console.warn("📛 Image failed to load, falling back to table");
        sizeContainer.innerHTML = "";
        if (toggleContainer) toggleContainer.style.display = "";
        renderSizeChartFallback();
      };

      sizeContainer.innerHTML = "";
      sizeContainer.appendChild(img);
    } else {
      if (toggleContainer) toggleContainer.style.display = "";
      renderSizeChartFallback();
    }
  }

  if (toggle) {
    toggle.addEventListener("change", function () {
      updateUnit(this.checked ? "in" : "cm");
    });
  }

  if (sizeContainer && (sizeChartDataRaw || desktopImageRaw || mobileImageRaw)) {
    renderSizeTable();
  }

  // ----- How to Measure Section -----
  const measureTextHTML = document.getElementById("how-to-measure-text")?.dataset.html;
  const measureImageHTML = document.getElementById("how-to-measure-img")?.dataset.html;
  const measureTextContainer = document.getElementById("measurecontent");
  const measureImageContainer = document.getElementById("measureimage");

  if (measureTextContainer && measureTextHTML) {
    measureTextContainer.innerHTML = measureTextHTML;
  }

  if (measureImageContainer && measureImageHTML) {
    const isImg = measureImageHTML.trim().startsWith('<img');
    if (isImg) {
      measureImageContainer.innerHTML = measureImageHTML;
    } else {
      const img = document.createElement("img");
      img.src = measureImageHTML;
      img.alt = "How to Measure";
      img.loading = "lazy";
      img.width = 400;
      measureImageContainer.innerHTML = "";
      measureImageContainer.appendChild(img);
    }
  }

  // ----- Region Table Section -----
  const regionData = document.getElementById("region-table-content")?.dataset.html;
  const regionContainer = document.getElementById("regionTableContainer");

  if (regionData && regionContainer) {
    try {
      const data = JSON.parse(regionData);
      if (!data?.columns || !data?.rows) return;

      const table = document.createElement("table");
      table.className = "size-guide-table";

      const thead = document.createElement("thead");
      const headRow = document.createElement("tr");
      data.columns.forEach(col => {
        const th = document.createElement("th");
        th.textContent = col;
        headRow.appendChild(th);
      });
      thead.appendChild(headRow);
      table.appendChild(thead);

      const tbody = document.createElement("tbody");
      data.rows.forEach(row => {
        const tr = document.createElement("tr");
        data.columns.forEach(col => {
          const td = document.createElement("td");
          td.textContent = row[col] || "";
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);

      regionContainer.innerHTML = "";
      regionContainer.appendChild(table);
    } catch (err) {
      console.error("❌ Error rendering region table:", err);
      regionContainer.textContent = "Unable to load region table.";
    }
  }
};

document.addEventListener("DOMContentLoaded", () => {
  window.initSizeGuide();
});
//Size guide JS

//Display none native color swatch on product page if there is grouped colors metafield
window.initColorSwitcherHider = function () {
  const hasColorSwitcher = document.querySelector('.product__info-wrapper .color-switcher');

  if (hasColorSwitcher) {
    document.querySelectorAll('.product-form__input--swatch').forEach(el => {
      el.style.display = 'none';
    });
  }
};

window.observeVariantSelects = function () {
  const variantWrapper = document.querySelector('variant-selects')?.parentElement;

  if (!variantWrapper) {
    console.warn('⚠️ Cannot observe variant-selects parent');
    return;
  }

  const observer = new MutationObserver(() => {
    console.log('🔄 Variant-selects re-rendered');
    window.initColorSwitcherHider();

    // OPTIONAL: reattach change listener if needed
    const radios = variantWrapper.querySelectorAll('input[type="radio"]');
    radios.forEach(radio => {
      radio.addEventListener('change', window.initColorSwitcherHider);
    });
  });

  observer.observe(variantWrapper, {
    childList: true,
    subtree: true,
  });
};

// Boot it
document.addEventListener('DOMContentLoaded', () => {
  window.initColorSwitcherHider();
  window.observeVariantSelects();
});
//Display none native color swatch on product page if there is grouped colors metafield

//coming soon subscription
window.initNotifyMeForm = function() {
  document.querySelectorAll('.notify-me-wrapper').forEach(function(wrapper) {
    const button = wrapper.querySelector('.notify-me-button');
    const formWrapper = wrapper.querySelector('.notify-me-form');
    const form = wrapper.querySelector('.notify-me-form-inner');
    const successMessage = wrapper.querySelector('#NotifyMeSuccess');

    if (button && formWrapper && form && successMessage) {
      button.addEventListener('click', function() {
        formWrapper.style.display = 'flex';
        button.style.display = 'none';
        successMessage.style.display = 'none'; // hide success if still showing
      });

      form.addEventListener('submit', function(e) {
        e.preventDefault();

        const formData = new FormData(form);
        const formParams = new URLSearchParams(formData);

        fetch('/contact', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formParams
        })
        .then(response => {
          if (response.ok) {
            formWrapper.style.display = 'none';
            successMessage.style.display = 'block';

            // Scroll to the closest grid__item
            const gridItem = wrapper.closest('.grid__item') || wrapper.closest('.card-wrapper');
            if (gridItem) {
              gridItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

          } else {
            alert('There was an error. Please try again.');
          }
        })
        .catch(error => {
          console.error(error);
          alert('There was an error. Please try again.');
        });
      });
    }
  });
};

document.addEventListener('DOMContentLoaded', function() {
  window.initNotifyMeForm();
});
document.addEventListener('DOMContentLoaded', function() {
  const params = new URLSearchParams(window.location.search);
  
  if (params.get('customer_posted') === 'true') {
    // First: clean the URL
    if (history.replaceState) {
      const cleanUrl = window.location.href.split('?')[0];
      window.history.replaceState({}, document.title, cleanUrl);
    }

    // Second: scroll back to the original product card
    const firstNotifyMeForm = document.querySelector('.notify-me-wrapper');
    if (firstNotifyMeForm) {
      const productCard = firstNotifyMeForm.closest('.grid__item') || firstNotifyMeForm.closest('.card-wrapper') || firstNotifyMeForm;
      if (productCard) {
        setTimeout(function() {
          productCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300); // slight delay for smooth scroll
      }
    }
  }
});

//coming soon subscription

//custom quick add size swatch on card product
window.initQuickAddBySize = function () {
  document.querySelectorAll('.product-sizes .size-badge').forEach(button => {
    button.addEventListener('click', function () {
      const variantId = this.getAttribute('data-variant-id');
      const productCard = this.closest('.card-product, .product-card, .grid__item'); // adjust class if needed
      const hiddenInput = productCard.querySelector('input[name="id"]');
      const submitButton = productCard.querySelector('.quick-add-button');

      if (variantId && hiddenInput && submitButton) {
        hiddenInput.value = variantId;
        submitButton.click();
      }
    });
  });
};

// Auto-run if you want
document.addEventListener('DOMContentLoaded', function() {
  if (typeof window.initQuickAddBySize === 'function') {
    window.initQuickAddBySize();
  }
});
//custom quick add size swatch on card product

//customize mouse drag on shopify <slider-component>
window.initSliderDrag = function () {
  document.querySelectorAll('slider-component .slider').forEach((slider) => {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('dragging');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('dragging');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('dragging');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.2; // adjust scroll speed here
      slider.scrollLeft = scrollLeft - walk;
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  window.initSliderDrag();
});
//customize mouse drag on shopify <slider-component>

//customize slider progress bar on shopify <slider-component>
window.initSliderProgress = function () {
  document.querySelectorAll('slider-component').forEach(slider => {
    const initSingleSlider = (sliderList) => {
      const slides = sliderList ? sliderList.querySelectorAll('li') : [];
      const progressBar = slider.querySelector('.slider-progress-bar');

      if (!sliderList || slides.length === 0 || !progressBar) return;

      const getVisibleItems = () => {
        const classList = sliderList.className;
        if (window.innerWidth <= 749) {
          if (classList.includes('grid--2-col-tablet-down')) return 2;
          if (classList.includes('grid--1-col-tablet-down')) return 1;
        } else {
          if (classList.includes('grid--4-col-desktop')) return 4;
          if (classList.includes('grid--3-col-desktop')) return 3;
          if (classList.includes('grid--2-col-desktop')) return 2;
          if (classList.includes('grid--1-col-desktop')) return 1;
        }
        return 1;
      };

      let visibleItems = getVisibleItems();
      let liWidth = slides[0]?.offsetWidth || 1;

      const updateProgressBar = () => {
        const scrollLeft = sliderList.scrollLeft;
        const maxScrollLeft = sliderList.scrollWidth - sliderList.clientWidth;
        const percent = maxScrollLeft > 0 ? Math.min(scrollLeft / maxScrollLeft, 1) * 100 : 0;
        progressBar.style.width = `${percent}%`;
      };

      // Reset scroll position and progress bar to 0
      const resetSlider = () => {
        sliderList.scrollLeft = 0;
        progressBar.style.width = '0%';
      };

      resetSlider(); // Reset when initializing

      // Recalculate on resize
      window.addEventListener('resize', () => {
        visibleItems = getVisibleItems();
        liWidth = slides[0]?.offsetWidth || 1;
        updateProgressBar();
      });

      // Click to scroll next/prev
      slider.addEventListener('click', (e) => {
        if (e.target.closest('[name="next"]')) {
          sliderList.scrollBy({ left: liWidth, behavior: 'smooth' });
        }
        if (e.target.closest('[name="previous"]')) {
          sliderList.scrollBy({ left: -liWidth, behavior: 'smooth' });
        }
      });

      // Scroll event updates the progress bar
      sliderList.addEventListener('scroll', () => {
        updateProgressBar();
      });
    };

    // Init all <ul> inside this slider-component
    slider.querySelectorAll('ul').forEach(sliderList => {
      initSingleSlider(sliderList);
    });
  });
};

// Run on page load
document.addEventListener('DOMContentLoaded', () => {
  window.initSliderProgress();
});

// Re-run and reset when tab is clicked
document.querySelectorAll('[role="tab"]').forEach(tab => {
  tab.addEventListener('click', () => {
    setTimeout(() => {
      document.querySelectorAll('slider-component ul').forEach(sliderList => {
        sliderList.scrollLeft = 0;
      });
      document.querySelectorAll('.slider-progress-bar').forEach(progressBar => {
        progressBar.style.width = '0%';
      });
      window.initSliderProgress();
    }, 200); // small delay after tab switching
  });
});

//customize slider progress bar on shopify <slider-component>

//upsell collection on cart drawer

// Bind size badge clicks properly
document.addEventListener('click', function (e) {
  const button = e.target.closest('.cart-upsell .size-badge');
  if (!button) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  const upsellCard = button.closest('.cart-upsell-card');
  if (!upsellCard) return;

  // Highlight selected
  upsellCard.querySelectorAll('.size-badge').forEach(b => b.classList.remove('selected'));
  button.classList.add('selected');

  // Update hidden input
  const productForm = upsellCard.querySelector('product-form');
  const actualForm = productForm?.querySelector('form');
  const hiddenInput = actualForm?.querySelector('input[name="id"]');
  if (!productForm || !actualForm || !hiddenInput) return;

  hiddenInput.value = variantId;

  // Submit the form (Shopify native AJAX)
  const submitButton = actualForm.querySelector('button[type="submit"]');
  if (submitButton) {
    submitButton.click(); // native submission = no redirect
  }
});

//swiper on cart drawer

//card product image carousel
// window.initCardMediaCarousel = function () {
//   document.querySelectorAll('.card-media-carousel').forEach((carousel) => {
//     if (carousel.classList.contains('swiper-initialized')) return;

//     const swiper = new Swiper(carousel, {
//       slidesPerView: 1,
//       loop: true,
//       navigation: {
//         nextEl: carousel.querySelector('.swiper-button-next'),
//         prevEl: carousel.querySelector('.swiper-button-prev'),
//       },
//       on: {
//         init: () => {
//           // Force all slides to have width 100%
//           carousel.querySelectorAll('.swiper-slide').forEach(slide => {
//             slide.style.width = '100%';
//           });
//         },
//         slideChange: () => {
//           // Reapply in case Swiper overrides it
//           carousel.querySelectorAll('.swiper-slide').forEach(slide => {
//             slide.style.width = '100%';
//           });
//         }
//       }
//     });
//   });
// };

// document.addEventListener('DOMContentLoaded', () => {
//   window.initCardMediaCarousel();
// });

//card product image carousel

//*indonesia redirect localization form */
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.disclosure__link[data-value]');
    if (!link) return;

    const selectedCountry = link.dataset.value;

    if (selectedCountry === 'ID') {
      e.preventDefault(); // Prevent default Shopify localization logic
      window.location.href = 'https://bybrik.id/';
    }
  });

//*indonesia redirect localization form*/

/*currency converter*/
//when clicked on a country localization form, simulate a click on the app currency converter to click on the new currency
const mapCountryToCurrency = {
  'Malaysia': 'MYR',
  'Singapore': 'SGD'
};

function getSelectedCountry() {
  const el = document.querySelector('.disclosure__link[aria-current="true"] .country');
  return el?.textContent.trim();
}

function getCurrentCurrencyCode() {
  const active = document.querySelector('.glc-list-item__active');
  return active?.getAttribute('glc-code');
}

function switchCurrencyIfNeeded() {
  const selectedCountry = getSelectedCountry();
  const expectedCurrency = mapCountryToCurrency[selectedCountry];
  if (!expectedCurrency) return;

  const currentCurrency = getCurrentCurrencyCode();
  if (currentCurrency === expectedCurrency) return;

  const target = document.querySelector(`.glc-list-item[glc-code="${expectedCurrency}"]`);
  if (target) {
    target.click();
    console.log(`Switched to ${expectedCurrency} for ${selectedCountry}`);
  }
}

// 👀 Observe changes to the country list
const targetNode = document.querySelector('.countries');
if (targetNode) {
  const observer = new MutationObserver(() => {
    switchCurrencyIfNeeded();
  });

  observer.observe(targetNode, {
    attributes: true,
    childList: true,
    subtree: true
  });
}

// 🕐 Run after a short delay (ensures DOM is ready even after AJAX load)
window.addEventListener('load', () => {
  setTimeout(switchCurrencyIfNeeded, 500); // Adjust if needed
});


/*currency converter*/

